import { render, staticRenderFns } from "./transbankRedirectPayment.vue?vue&type=template&id=1c1185c6"
import script from "./transbankRedirectPayment.vue?vue&type=script&lang=ts"
export * from "./transbankRedirectPayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports